// Generated by scripts/theme-seed.ts from seed/themes.json and src/modules/theme/tokens.ts; do not edit.
// The default Light and Dark rows of the themes table, for the app before it has read the table.
import type { ThemeRow } from './themes';

export const DEFAULT_THEMES: ThemeRow[] = [
  {
    "key": "light",
    "label": "Lureo Light",
    "description": "Lureo's own light theme: white surfaces, deep navy text and the berry brand colour, with a bright aqua accent on the main action. It ships with the app and is the light default.",
    "mode": "light",
    "family": null,
    "visible": true,
    "sortOrder": 0,
    "tokens": {
      "lureo-surface": "oklch(1 0 0)",
      "lureo-page": "oklch(0.962 0 0)",
      "lureo-neutral-subtle": "oklch(0.985 0 0)",
      "lureo-neutral": "oklch(0.9681 0.0007 269.49)",
      "lureo-neutral-strong": "oklch(0.92 0.0018 269.49)",
      "lureo-thumb": "oklch(0.9594 0.0068 325.63)",
      "lureo-thumb-strong": "oklch(0.9319 0.0124 317.74)",
      "lureo-meter-empty": "oklch(0.8513 0.0137 286.1)",
      "lureo-backdrop-from": "oklch(0.9815 0.0004 269.49)",
      "lureo-chrome": "linear-gradient(135deg, oklch(0.9827 0.0026 286.35), oklch(0.961 0.0029 264.54))",
      "lureo-editor-bar": "linear-gradient(135deg, oklch(0.9815 0.0004 269.49), oklch(0.96 0 0))",
      "lureo-menu": "oklch(1 0 0)",
      "lureo-dialog": "oklch(0.962 0 0)",
      "lureo-popover": "oklch(1 0 0)",
      "lureo-on-menu": "oklch(0.3703 0.0119 285.81)",
      "lureo-on-menu-subtle": "oklch(0.4582 0.0187 306.1)",
      "lureo-on-menu-subtlest": "oklch(0.6617 0.0246 321.38)",
      "lureo-menu-hover": "oklch(0.4187 0.0846 338.58 / 0.06)",
      "lureo-on-menu-hover": "oklch(0.3703 0.0119 285.81)",
      "lureo-menu-line": "oklch(0.9228 0.0125 317.74)",
      "lureo-bar-line": "oklch(1 0 0 / 0.3)",
      "lureo-backdrop": "linear-gradient(135deg, oklch(0.9815 0.0004 269.49), oklch(0.96 0 0))",
      "lureo-bar": "oklch(1 0 0 / 0.2)",
      "lureo-scrim": "oklch(0 0 0 / 0.8)",
      "lureo-ink-strong": "oklch(0.2591 0.0165 269.49)",
      "lureo-ink": "oklch(0.3703 0.0119 285.81)",
      "lureo-ink-subtle": "oklch(0.4582 0.0187 306.1)",
      "lureo-ink-subtlest": "oklch(0.6617 0.0246 321.38)",
      "lureo-page-ink-strong": "oklch(0.2591 0.0165 269.49)",
      "lureo-page-ink": "oklch(0.3703 0.0119 285.81)",
      "lureo-page-ink-subtle": "oklch(0.4582 0.0187 306.1)",
      "lureo-page-ink-subtlest": "oklch(0.6617 0.0246 321.38)",
      "lureo-on-emphasis": "oklch(1 0 0)",
      "lureo-on-emphasis-subtle": "oklch(0.9489 0.0041 248.01)",
      "lureo-on-emphasis-subtlest": "oklch(0.737 0.0209 248.01)",
      "lureo-bar-ink": "oklch(0.3024 0.0328 276.92)",
      "lureo-line": "oklch(0.9228 0.0125 317.74)",
      "lureo-line-strong": "oklch(0.8627 0.0144 318.7)",
      "lureo-card-line": "oklch(1 0 0)",
      "lureo-highlight": "oklch(1 0 0)",
      "lureo-hover": "oklch(0.4187 0.0846 338.58 / 0.06)",
      "lureo-brand-ink-pressed": "oklch(0.3692 0.0604 334.04)",
      "lureo-danger-hover": "oklch(0.6695 0.1306 38.28)",
      "lureo-danger-pressed": "oklch(0.6182 0.1317 38.36)",
      "lureo-disabled-opacity": "0.5",
      "lureo-focus": "oklch(0.4187 0.0846 338.58)",
      "lureo-focus-width": "2px",
      "lureo-focus-offset": "2px",
      "lureo-focus-ring": "0 0 #0000",
      "lureo-focus-style": "solid",
      "lureo-disabled-fill": "none",
      "lureo-on-disabled": "oklch(0.6617 0.0246 321.38)",
      "lureo-brand": "oklch(0.4187 0.0846 338.58)",
      "lureo-brand-ink": "oklch(0.4187 0.0846 338.58)",
      "lureo-on-brand-ink": "oklch(1 0 0)",
      "lureo-on-brand": "oklch(1 0 0)",
      "lureo-link": "oklch(0.4184 0.0904 236.26)",
      "lureo-page-link": "oklch(0.4184 0.0904 236.26)",
      "lureo-link-decoration": "underline",
      "lureo-link-decoration-hover": "underline",
      "lureo-link-underline-offset": "2px",
      "lureo-link-visited": "oklch(0.4184 0.0904 236.26)",
      "lureo-link-pressed": "oklch(0.4184 0.0904 236.26 / 0.8)",
      "lureo-link-hover": "oklch(0.4184 0.0904 236.26 / 0.8)",
      "lureo-page-link-hover": "oklch(0.4184 0.0904 236.26 / 0.8)",
      "lureo-link-hover-wash": "0 0 #0000",
      "lureo-secondary": "oklch(0.4248 0.0973 327.72)",
      "lureo-on-secondary": "oklch(1 0 0)",
      "lureo-secondary-hover": "oklch(0.2694 0.058 248.01 / 0.05)",
      "lureo-secondary-pressed": "oklch(0.2694 0.058 248.01 / 0.15)",
      "lureo-on-secondary-hover": "oklch(1 0 0)",
      "lureo-on-secondary-pressed": "oklch(1 0 0)",
      "lureo-accent": "oklch(0.9145 0.1311 185.99)",
      "lureo-emphasis": "oklch(0.2694 0.058 248.01)",
      "lureo-emphasis-strong": "oklch(0.2238 0.1052 323.99)",
      "lureo-glyph": "oklch(0.2694 0.058 248.01)",
      "lureo-button-ink": "oklch(0.3024 0.0328 276.92)",
      "lureo-emphasis-ink": "oklch(0.2694 0.058 248.01)",
      "lureo-success": "oklch(0.7205 0.192 149.49)",
      "lureo-success-ink": "oklch(0.5248 0.1373 149.83)",
      "lureo-warning": "oklch(0.7697 0.1645 70.61)",
      "lureo-warning-ink": "oklch(0.5542 0.1447 49.16)",
      "lureo-danger": "oklch(0.7203 0.1295 38.15)",
      "lureo-danger-ink": "oklch(0.5527 0.1294 38.35)",
      "lureo-aqua": "oklch(0.8826 0.1032 177.8)",
      "lureo-aqua-ink": "oklch(0.526 0.0972 177.8)",
      "lureo-teal": "oklch(0.6427 0.1027 202.46)",
      "lureo-signal-strong": "oklch(0.6427 0.1027 202.46)",
      "lureo-mint": "oklch(0.9056 0.1464 170.01)",
      "lureo-mint-ink": "oklch(0.525 0.1024 170.01)",
      "lureo-berry-ink": "oklch(0.2238 0.1052 323.99)",
      "lureo-on-berry-ink": "oklch(1 0 0)",
      "lureo-coral": "oklch(0.7203 0.1295 38.15)",
      "lureo-coral-ink": "oklch(0.552 0.1295 38.15)",
      "lureo-sky": "oklch(0.7288 0.1184 236.76)",
      "lureo-sky-ink": "oklch(0.534 0.1164 236.76)",
      "lureo-lavender": "oklch(0.7569 0.1124 289.22)",
      "lureo-lavender-ink": "oklch(0.546 0.1124 289.22)",
      "lureo-violet": "oklch(0.5762 0.1105 289.37)",
      "lureo-on-violet": "oklch(1 0 0)",
      "lureo-grey-strong": "oklch(0.6349 0.0226 310.97)",
      "lureo-grey": "oklch(0.8211 0.0111 310.97)",
      "lureo-shade": "oklch(0 0 0)",
      "lureo-cta": "oklch(0.9145 0.1311 185.99)",
      "lureo-cta-to": "oklch(0.7548 0.095 232.93)",
      "lureo-cta-angle": "to bottom right",
      "lureo-cta-fill": "none",
      "lureo-on-cta": "oklch(0.2694 0.058 248.01)",
      "lureo-on-cta-soft": "oklch(0.2694 0.058 248.01)",
      "lureo-cta-hover": "oklch(0.6617 0.0246 321.38 / 0.1)",
      "lureo-cta-pressed": "oklch(0.6617 0.0246 321.38 / 0.35)",
      "lureo-on-cta-hover": "oklch(0.4975 0.0748 239.07)",
      "lureo-on-cta-pressed": "oklch(0.4247 0.0692 241.45)",
      "lureo-cta-label-hover": "oklch(0.2694 0.058 248.01)",
      "lureo-cta-label-pressed": "oklch(0.2694 0.058 248.01)",
      "lureo-cta-soft-from": "oklch(0.9303 0.1043 186.39)",
      "lureo-cta-soft-to": "oklch(0.8505 0.1219 185.99)",
      "lureo-cta-soft-hover": "oklch(0.2694 0.058 248.01 / 0.05)",
      "lureo-cta-soft-pressed": "oklch(0.2694 0.058 248.01 / 0.15)",
      "lureo-chip": "oklch(1 0 0 / 0)",
      "lureo-on-chip": "oklch(0.3703 0.0119 285.81)",
      "lureo-chip-line": "oklch(0.9228 0.0125 317.74)",
      "lureo-chip-on": "oklch(1 0 0 / 0)",
      "lureo-on-chip-on": "oklch(0.4187 0.0846 338.58)",
      "lureo-chip-on-line": "oklch(0.4187 0.0846 338.58)",
      "lureo-chip-hover": "oklch(1 0 0 / 0)",
      "lureo-on-chip-hover": "oklch(0.3703 0.0119 285.81)",
      "lureo-chip-hover-line": "oklch(0.4187 0.0846 338.58)",
      "lureo-chip-on-hover": "oklch(1 0 0 / 0)",
      "lureo-chip-line-width": "1.5px",
      "lureo-upload-line-width": "2px",
      "lureo-outline-hover": "oklch(0.2694 0.058 248.01 / 0.1)",
      "lureo-outline-pressed": "oklch(0.2694 0.058 248.01 / 0.2)",
      "lureo-on-outline-hover": "oklch(0.4187 0.0846 338.58)",
      "lureo-outline-line-hover": "oklch(0.4187 0.0846 338.58)",
      "lureo-card-hover-line": "oklch(0.4187 0.0846 338.58)",
      "lureo-card-hover": "oklch(1 0 0)",
      "lureo-field": "oklch(0.962 0 0)",
      "lureo-field-line": "oklch(0.9228 0.0125 317.74)",
      "lureo-field-line-width": "1px",
      "lureo-field-line-focus": "oklch(0.4187 0.0846 338.58)",
      "lureo-field-placeholder": "oklch(0.6617 0.0246 321.38)",
      "lureo-tooltip": "oklch(0.2591 0.0165 269.49)",
      "lureo-on-tooltip": "oklch(1 0 0)",
      "lureo-segment-on": "oklch(1 0 0)",
      "lureo-on-segment-on": "oklch(0.3703 0.0119 285.81)",
      "lureo-segmented-line": "oklch(0 0 0 / 0)",
      "lureo-switch-off": "oklch(0.8261 0.0153 316.7)",
      "lureo-switch-thumb": "oklch(1 0 0)",
      "lureo-switch-thumb-on": "oklch(1 0 0)",
      "lureo-shadow-switch-off": "0 0 #0000",
      "lureo-badge": "oklch(0.4187 0.0846 338.58)",
      "lureo-scrollbar": "oklch(0.6617 0.0246 321.38)",
      "lureo-button-ring": "oklch(0.8627 0.0144 318.7 / 0.5)",
      "lureo-tab-on": "oklch(0.2694 0.058 248.01 / 0.1)",
      "lureo-on-tab-on": "oklch(0.2591 0.0165 269.49)",
      "lureo-segmented-tray": "oklch(0.4187 0.0846 338.58 / 0.06)",
      "lureo-switch-on": "oklch(0.4187 0.0846 338.58)",
      "lureo-selected": "oklch(0.4187 0.0846 338.58 / 0.1)",
      "lureo-on-selected": "oklch(0.4187 0.0846 338.58)",
      "lureo-selected-line": "oklch(0.4187 0.0846 338.58)",
      "lureo-tag-line": "oklch(0.2238 0.1052 323.99 / 0.4)",
      "lureo-tag-line-width": "1px",
      "lureo-inset": "oklch(0.4187 0.0846 338.58 / 0.04)",
      "lureo-inset-line": "oklch(0.4187 0.0846 338.58 / 0.18)",
      "lureo-inset-line-width": "1px",
      "lureo-gradient-from": "oklch(0.2694 0.058 248.01)",
      "lureo-gradient-via": "oklch(0.4248 0.0973 327.72)",
      "lureo-gradient-to": "oklch(0.4248 0.0973 327.72)",
      "lureo-gradient-angle": "to bottom right",
      "lureo-gradient-end": "0.7",
      "lureo-plan-line": "oklch(0.2901 0.1025 325.16)",
      "lureo-plan-link": "oklch(0.8031 0.1118 215.46)",
      "lureo-viewport-sky-top": "oklch(0.9789 0.0293 187.53)",
      "lureo-viewport-sky-bottom": "oklch(1 0 0)",
      "lureo-viewport-floor": "oklch(0.9681 0.0007 269.49)",
      "lureo-viewport-grid": "oklch(0.9036 0.0154 239.62)",
      "lureo-viewport-grid-strong": "oklch(0.711 0.0064 269.49)",
      "lureo-timeline-ruler-ink": "oklch(0.2238 0.1052 323.99)",
      "lureo-timeline-clip": "oklch(0.9815 0.0004 269.49)",
      "lureo-timeline-track": "oklch(0.8884 0 0)",
      "lureo-timeline-track-strong": "oklch(0.7543 0 0)",
      "lureo-timeline-track-faint": "oklch(0.9551 0 0)",
      "lureo-timeline-track-faint-strong": "oklch(0.8975 0 0)",
      "lureo-timeline-clip-line": "oklch(0.2694 0.058 248.01 / 0.7)",
      "lureo-timeline-clip-on": "oklch(0.4187 0.0846 338.58)",
      "lureo-on-timeline-clip-on": "oklch(1 0 0)",
      "lureo-timeline-playhead": "oklch(0.3692 0.0604 334.04)",
      "lureo-gizmo-ring": "oklch(0.9301 0.1043 170.39)",
      "lureo-handle": "oklch(0.87 0 0)",
      "lureo-style-bubble": "oklch(0.9409 0.087 186.65)",
      "lureo-tile-shade": "oklch(0.4228 0.0458 248.01)",
      "lureo-checker-light": "oklch(0.9034 0.006 310.97)",
      "lureo-checker-dark": "oklch(0.7038 0.0183 310.97)",
      "lureo-map-land": "oklch(0.9704 0.0007 269.49)",
      "lureo-map-water": "oklch(0.837 0.0036 269.49)",
      "lureo-map-park": "oklch(0.9185 0.0018 269.49)",
      "lureo-map-line": "oklch(0.8815 0.0026 269.49)",
      "lureo-map-label": "oklch(0.4962 0.0112 269.49)",
      "lureo-map-water-label": "oklch(0.6962 0.0068 269.49)",
      "lureo-map-parcel-label": "oklch(0.8 0.0045 269.49)",
      "lureo-shadow-raised": "0px 4px 24px oklch(0.9145 0.1311 185.99 / 0.1)",
      "lureo-shadow-float": "0px 4px 24px oklch(0.9145 0.1311 185.99 / 0.1), 0 16px 48px oklch(0 0 0 / 0.12)",
      "lureo-shadow-overlay": "0px 1px 10px 1px oklch(0 0 0 / 0.175), inset 0 1px 0 oklch(1 0 0 / 0), 0 0 0 1px oklch(0 0 0 / 0)",
      "lureo-shadow-bar": "0 8px 32px oklch(0 0 0 / 0.08), 0 0 0 1px oklch(1 0 0 / 0.1)",
      "lureo-shadow-modal": "0px 16px 48px oklch(0 0 0 / 0.12), 0 0 0 1px oklch(1 0 0 / 0.15)",
      "lureo-shadow-lift": "0px 12px 40px oklch(0.9145 0.1311 185.99 / 0.15)",
      "lureo-shadow-lift-hover": "0px 12px 40px oklch(0.9145 0.1311 185.99 / 0.15)",
      "lureo-shadow-card-hover": "0px 4px 24px oklch(0.9145 0.1311 185.99 / 0.1)",
      "lureo-shadow-sheet": "inset 0 1px 0 oklch(1 0 0 / 0), 0 0 0 1px oklch(0 0 0 / 0), 0 0 19px 1.5px oklch(0 0 0 / 0)",
      "lureo-shadow-control": "0px 1px 2px oklch(0.2694 0.058 248.01 / 0.08)",
      "lureo-shadow-button": "0 0 #0000",
      "lureo-shadow-cta": "0 0 #0000",
      "lureo-shadow-outline-button": "0 0 #0000",
      "lureo-shadow-button-pressed": "0 0 #0000",
      "lureo-shadow-button-hover": "0 0 #0000",
      "lureo-shadow-outline-button-hover": "0 0 #0000",
      "lureo-shadow-cta-hover": "0 0 #0000",
      "lureo-shadow-tab": "0px 1px 2px oklch(0.2694 0.058 248.01 / 0.08)",
      "lureo-shadow-cta-pressed": "0 0 #0000",
      "lureo-shadow-outline-button-pressed": "0 0 #0000",
      "lureo-shadow-solid": "0 0 #0000",
      "lureo-shadow-solid-hover": "0 0 #0000",
      "lureo-shadow-solid-pressed": "0 0 #0000",
      "lureo-shadow-danger": "0 0 #0000",
      "lureo-shadow-danger-hover": "0 0 #0000",
      "lureo-shadow-danger-pressed": "0 0 #0000",
      "lureo-shadow-segment-on": "0px 1px 2px oklch(0.2694 0.058 248.01 / 0.08)",
      "lureo-shadow-panel-card": "0 0 #0000",
      "lureo-field-focus": "0 0 0 2px oklch(0.9145 0.1311 185.99 / 0.7)",
      "lureo-title-shadow": "none",
      "lureo-sheen": "1",
      "lureo-photo-shade": "1",
      "lureo-photo-shade-tint": "oklch(0.2694 0.058 248.01)",
      "lureo-photo-brightness": "1",
      "lureo-photo-hover-brightness": "1",
      "lureo-photo-veil": "oklch(0 0 0 / 0)",
      "lureo-glass": "1",
      "lureo-blur-sm": "4px",
      "lureo-blur-lg": "16px",
      "lureo-radius": "0.75rem",
      "lureo-radius-control": "1rem",
      "lureo-radius-button-pill": "9999px",
      "lureo-border-width": "1px",
      "lureo-radius-sm": "0.5rem",
      "lureo-radius-lg": "1rem",
      "lureo-radius-xl": "1.5rem",
      "lureo-radius-pill": "9999px",
      "lureo-radius-control-lg": "1.5rem",
      "lureo-radius-tag": "9999px",
      "lureo-radius-tab": "0.5rem",
      "lureo-radius-tooltip": "0.75rem",
      "lureo-radius-avatar": "9999px",
      "lureo-radius-segmented": "9999px",
      "lureo-radius-chip": "9999px",
      "lureo-radius-menu": "0.75rem",
      "lureo-radius-dialog": "1rem",
      "lureo-radius-field": "0.75rem",
      "lureo-border-width-medium": "1.5px",
      "lureo-border-width-strong": "2px",
      "lureo-border-width-heavy": "3px",
      "lureo-line-style": "solid",
      "lureo-duration-fast": "150ms",
      "lureo-duration-moderate": "200ms",
      "lureo-duration-slow": "300ms",
      "lureo-duration-button": "300ms",
      "lureo-duration-slower": "500ms",
      "lureo-duration-slowest": "700ms",
      "lureo-duration-sweep": "1200ms",
      "lureo-backdrop-drift": "0s",
      "lureo-easing-standard": "cubic-bezier(0.4, 0, 0.2, 1)",
      "lureo-easing-enter": "cubic-bezier(0, 0, 0.2, 1)",
      "lureo-easing-exit": "cubic-bezier(0.4, 0, 1, 1)",
      "lureo-press-scale": "1",
      "lureo-card-hover-scale": "1.02",
      "lureo-photo-hover-scale": "1",
      "lureo-hero-press-scale": "0.995",
      "lureo-press-offset": "0px",
      "lureo-hover-offset": "0px",
      "lureo-hover-offset-x": "0px",
      "lureo-hover-scale": "1",
      "lureo-layer-bar": "40",
      "lureo-layer-overlay": "50",
      "lureo-layer-tooltip": "110",
      "lureo-layer-blocker": "9999",
      "lureo-layer-tour": "10000",
      "lureo-layer-toast": "10010",
      "lureo-font-ui": "ui-sans-serif, system-ui, sans-serif",
      "lureo-font-prose": "Fraunces, Georgia, serif",
      "lureo-font-mono": "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
      "lureo-font-display": "ui-sans-serif, system-ui, sans-serif",
      "lureo-weight-text": "400",
      "lureo-weight-heading": "700",
      "lureo-label-case": "none",
      "lureo-tab-case": "none",
      "lureo-title-case": "none",
      "lureo-label-tracking": "0em",
      "lureo-text-tracking": "0em",
      "lureo-font-features": "normal",
      "lureo-weight-subheading": "600",
      "lureo-weight-button": "600",
      "lureo-weight-label": "500",
      "lureo-title-tracking": "0em",
      "lureo-title-style": "normal",
      "lureo-label-style": "normal",
      "lureo-label-shadow": "none",
      "lureo-title-flicker": "0s",
      "lureo-title-leading": "1",
      "lureo-title-width": "100%",
      "lureo-title-indent": "0em",
      "lureo-title-fill": "none",
      "lureo-title-rule": "0px",
      "lureo-title-rule-ink": "oklch(0.2591 0.0165 269.49)",
      "lureo-weight-overline": "300",
      "lureo-overline-case": "uppercase",
      "lureo-font-label": "ui-sans-serif, system-ui, sans-serif",
      "lureo-overline-ink": "oklch(0.4582 0.0187 306.1)",
      "lureo-overline-tracking": "0.15em",
      "lureo-texture-pattern": "none",
      "lureo-texture-strength": "0",
      "lureo-texture-size": "256px",
      "lureo-logo-style": "artwork"
    }
  },
  {
    "key": "dark",
    "label": "Lureo Dark",
    "description": "Lureo's own dark theme: charcoal surfaces tinted toward the brand berry, near-white text and selections, with the same aqua accent. It ships with the app and is the dark default.",
    "mode": "dark",
    "family": null,
    "visible": true,
    "sortOrder": 10,
    "tokens": {
      "lureo-surface": "oklch(0.2118 0.028 324)",
      "lureo-page": "oklch(0.1697 0.0224 324)",
      "lureo-neutral-subtle": "oklch(0.1913 0.0253 324)",
      "lureo-neutral": "oklch(0.2538 0.0264 324)",
      "lureo-neutral-strong": "oklch(0.3153 0.0241 324)",
      "lureo-thumb": "oklch(0.2538 0.0264 324)",
      "lureo-thumb-strong": "oklch(0.3153 0.0241 324)",
      "lureo-meter-empty": "oklch(0.4368 0.0196 324)",
      "lureo-backdrop-from": "oklch(0.2433 0.0268 324)",
      "lureo-chrome": "linear-gradient(135deg, oklch(0.2433 0.0268 324), oklch(0.2016 0.0267 324))",
      "lureo-editor-bar": "linear-gradient(135deg, oklch(0.2433 0.0268 324), oklch(0.2016 0.0267 324))",
      "lureo-menu": "oklch(0.2118 0.028 324)",
      "lureo-dialog": "oklch(0.1697 0.0224 324)",
      "lureo-popover": "oklch(0.2563 0.0263 324)",
      "lureo-on-menu": "oklch(0.8704 0.0034 324)",
      "lureo-on-menu-subtle": "oklch(0.7879 0.0065 324)",
      "lureo-on-menu-subtlest": "oklch(0.69 0.0102 324)",
      "lureo-menu-hover": "oklch(0.9619 0 0 / 0.06)",
      "lureo-on-menu-hover": "oklch(0.8704 0.0034 324)",
      "lureo-menu-line": "oklch(0.3056 0.0245 324)",
      "lureo-bar-line": "oklch(1 0 0 / 0.3)",
      "lureo-backdrop": "linear-gradient(135deg, oklch(0.2433 0.0268 324), oklch(0.2016 0.0267 324))",
      "lureo-bar": "oklch(0.2118 0.028 324 / 0.2)",
      "lureo-scrim": "oklch(0 0 0 / 0.8)",
      "lureo-ink-strong": "oklch(0.9619 0 0)",
      "lureo-ink": "oklch(0.8704 0.0034 324)",
      "lureo-ink-subtle": "oklch(0.7879 0.0065 324)",
      "lureo-ink-subtlest": "oklch(0.69 0.0102 324)",
      "lureo-page-ink-strong": "oklch(0.9619 0 0)",
      "lureo-page-ink": "oklch(0.8704 0.0034 324)",
      "lureo-page-ink-subtle": "oklch(0.7879 0.0065 324)",
      "lureo-page-ink-subtlest": "oklch(0.69 0.0102 324)",
      "lureo-on-emphasis": "oklch(1 0 0)",
      "lureo-on-emphasis-subtle": "oklch(0.9489 0.0041 248.01)",
      "lureo-on-emphasis-subtlest": "oklch(0.737 0.0209 248.01)",
      "lureo-bar-ink": "oklch(0.9619 0 0)",
      "lureo-line": "oklch(0.3056 0.0245 324)",
      "lureo-line-strong": "oklch(0.3828 0.0216 324)",
      "lureo-card-line": "oklch(0.2118 0.028 324)",
      "lureo-highlight": "oklch(1 0 0)",
      "lureo-hover": "oklch(0.9619 0 0 / 0.06)",
      "lureo-brand-ink-pressed": "oklch(0.88 0 0)",
      "lureo-danger-hover": "oklch(0.6695 0.1306 38.28)",
      "lureo-danger-pressed": "oklch(0.6182 0.1317 38.36)",
      "lureo-disabled-opacity": "0.5",
      "lureo-focus": "oklch(0.9619 0 0)",
      "lureo-focus-width": "2px",
      "lureo-focus-offset": "2px",
      "lureo-focus-ring": "0 0 #0000",
      "lureo-focus-style": "solid",
      "lureo-disabled-fill": "oklch(0.3153 0.0241 324)",
      "lureo-on-disabled": "oklch(0.69 0.0102 324)",
      "lureo-brand": "oklch(0.5055 0.1123 338.92)",
      "lureo-brand-ink": "oklch(0.9619 0 0)",
      "lureo-on-brand-ink": "oklch(0.2238 0.1052 323.99)",
      "lureo-on-brand": "oklch(1 0 0)",
      "lureo-link": "oklch(0.7288 0.1184 236.76)",
      "lureo-page-link": "oklch(0.7288 0.1184 236.76)",
      "lureo-link-decoration": "underline",
      "lureo-link-decoration-hover": "underline",
      "lureo-link-underline-offset": "2px",
      "lureo-link-visited": "oklch(0.7288 0.1184 236.76)",
      "lureo-link-pressed": "oklch(0.7288 0.1184 236.76 / 0.8)",
      "lureo-link-hover": "oklch(0.7288 0.1184 236.76 / 0.8)",
      "lureo-page-link-hover": "oklch(0.7288 0.1184 236.76 / 0.8)",
      "lureo-link-hover-wash": "0 0 #0000",
      "lureo-secondary": "oklch(0.5393 0.1284 327.78)",
      "lureo-on-secondary": "oklch(1 0 0)",
      "lureo-secondary-hover": "oklch(0.2694 0.058 248.01 / 0.05)",
      "lureo-secondary-pressed": "oklch(0.2694 0.058 248.01 / 0.15)",
      "lureo-on-secondary-hover": "oklch(1 0 0)",
      "lureo-on-secondary-pressed": "oklch(1 0 0)",
      "lureo-accent": "oklch(0.9145 0.1311 185.99)",
      "lureo-emphasis": "oklch(0.2694 0.058 248.01)",
      "lureo-emphasis-strong": "oklch(0.2238 0.1052 323.99)",
      "lureo-glyph": "oklch(0.8716 0.0034 324)",
      "lureo-button-ink": "oklch(0.8704 0.0034 324)",
      "lureo-emphasis-ink": "oklch(0.9619 0 0)",
      "lureo-success": "oklch(0.7205 0.192 149.49)",
      "lureo-success-ink": "oklch(0.7999 0.1816 151.78)",
      "lureo-warning": "oklch(0.7697 0.1645 70.61)",
      "lureo-warning-ink": "oklch(0.8334 0.1641 83.87)",
      "lureo-danger": "oklch(0.7203 0.1295 38.15)",
      "lureo-danger-ink": "oklch(0.7203 0.1295 38.15)",
      "lureo-aqua": "oklch(0.8826 0.1032 177.8)",
      "lureo-aqua-ink": "oklch(0.8826 0.1032 177.8)",
      "lureo-teal": "oklch(0.6427 0.1027 202.46)",
      "lureo-signal-strong": "oklch(0.8826 0.1032 177.8)",
      "lureo-mint": "oklch(0.9056 0.1464 170.01)",
      "lureo-mint-ink": "oklch(0.9056 0.1464 170.01)",
      "lureo-berry-ink": "oklch(0.9619 0 0)",
      "lureo-on-berry-ink": "oklch(0.2238 0.1052 323.99)",
      "lureo-coral": "oklch(0.7203 0.1295 38.15)",
      "lureo-coral-ink": "oklch(0.7203 0.1295 38.15)",
      "lureo-sky": "oklch(0.7288 0.1184 236.76)",
      "lureo-sky-ink": "oklch(0.7288 0.1184 236.76)",
      "lureo-lavender": "oklch(0.7569 0.1124 289.22)",
      "lureo-lavender-ink": "oklch(0.7569 0.1124 289.22)",
      "lureo-violet": "oklch(0.78 0.11 289.3)",
      "lureo-on-violet": "oklch(0.2238 0.1052 323.99)",
      "lureo-grey-strong": "oklch(0.6349 0.0226 310.97)",
      "lureo-grey": "oklch(0.8211 0.0111 310.97)",
      "lureo-shade": "oklch(0 0 0)",
      "lureo-cta": "oklch(0.9145 0.1311 185.99)",
      "lureo-cta-to": "oklch(0.7548 0.095 232.93)",
      "lureo-cta-angle": "to bottom right",
      "lureo-cta-fill": "none",
      "lureo-on-cta": "oklch(0.2694 0.058 248.01)",
      "lureo-on-cta-soft": "oklch(0.2694 0.058 248.01)",
      "lureo-cta-hover": "oklch(0.5448 0.0156 324 / 0.1)",
      "lureo-cta-pressed": "oklch(0.5448 0.0156 324 / 0.35)",
      "lureo-on-cta-hover": "oklch(0.4975 0.0748 239.07)",
      "lureo-on-cta-pressed": "oklch(0.4247 0.0692 241.45)",
      "lureo-cta-label-hover": "oklch(0.2694 0.058 248.01)",
      "lureo-cta-label-pressed": "oklch(0.2694 0.058 248.01)",
      "lureo-cta-soft-from": "oklch(0.9303 0.1043 186.39)",
      "lureo-cta-soft-to": "oklch(0.8505 0.1219 185.99)",
      "lureo-cta-soft-hover": "oklch(0.2694 0.058 248.01 / 0.05)",
      "lureo-cta-soft-pressed": "oklch(0.2694 0.058 248.01 / 0.15)",
      "lureo-chip": "oklch(0.2118 0.028 324)",
      "lureo-on-chip": "oklch(0.8704 0.0034 324)",
      "lureo-chip-line": "oklch(0.3056 0.0245 324)",
      "lureo-chip-on": "oklch(0.9619 0 0 / 0.1)",
      "lureo-on-chip-on": "oklch(0.9619 0 0)",
      "lureo-chip-on-line": "oklch(0.9619 0 0)",
      "lureo-chip-hover": "oklch(0.2118 0.028 324)",
      "lureo-on-chip-hover": "oklch(0.8704 0.0034 324)",
      "lureo-chip-hover-line": "oklch(0.9619 0 0)",
      "lureo-chip-on-hover": "oklch(0.9619 0 0 / 0.1)",
      "lureo-chip-line-width": "1.5px",
      "lureo-upload-line-width": "2px",
      "lureo-outline-hover": "oklch(0.2694 0.058 248.01 / 0.1)",
      "lureo-outline-pressed": "oklch(0.2694 0.058 248.01 / 0.2)",
      "lureo-on-outline-hover": "oklch(0.9619 0 0)",
      "lureo-outline-line-hover": "oklch(0.9619 0 0)",
      "lureo-card-hover-line": "oklch(0.9619 0 0)",
      "lureo-card-hover": "oklch(0.2118 0.028 324)",
      "lureo-field": "oklch(0.1697 0.0224 324)",
      "lureo-field-line": "oklch(0.3056 0.0245 324)",
      "lureo-field-line-width": "1px",
      "lureo-field-line-focus": "oklch(0.9619 0 0)",
      "lureo-field-placeholder": "oklch(0.69 0.0102 324)",
      "lureo-tooltip": "oklch(0.9619 0 0)",
      "lureo-on-tooltip": "oklch(0.2118 0.028 324)",
      "lureo-segment-on": "oklch(0.2118 0.028 324)",
      "lureo-on-segment-on": "oklch(0.8704 0.0034 324)",
      "lureo-segmented-line": "oklch(0 0 0 / 0)",
      "lureo-switch-off": "oklch(0.3828 0.0216 324)",
      "lureo-switch-thumb": "oklch(0.9619 0 0)",
      "lureo-switch-thumb-on": "oklch(0.9619 0 0)",
      "lureo-shadow-switch-off": "0 0 #0000",
      "lureo-badge": "oklch(0.5055 0.1123 338.92)",
      "lureo-scrollbar": "oklch(0.5448 0.0156 324)",
      "lureo-button-ring": "oklch(0.3828 0.0216 324 / 0.5)",
      "lureo-tab-on": "oklch(0.2694 0.058 248.01 / 0.1)",
      "lureo-on-tab-on": "oklch(0.9619 0 0)",
      "lureo-segmented-tray": "oklch(0.9619 0 0 / 0.06)",
      "lureo-switch-on": "oklch(0.5055 0.1123 338.92)",
      "lureo-selected": "oklch(0.9619 0 0 / 0.1)",
      "lureo-on-selected": "oklch(0.9619 0 0)",
      "lureo-selected-line": "oklch(0.9619 0 0)",
      "lureo-tag-line": "oklch(0.9619 0 0 / 0.4)",
      "lureo-tag-line-width": "1px",
      "lureo-inset": "oklch(0.9619 0 0 / 0.04)",
      "lureo-inset-line": "oklch(0.9619 0 0 / 0.18)",
      "lureo-inset-line-width": "1px",
      "lureo-gradient-from": "oklch(0.4248 0.0973 327.72)",
      "lureo-gradient-via": "oklch(0.27 0.06 325)",
      "lureo-gradient-to": "oklch(0.1697 0.0224 324)",
      "lureo-gradient-angle": "to bottom right",
      "lureo-gradient-end": "1",
      "lureo-plan-line": "oklch(0.3279 0.1128 325.41)",
      "lureo-plan-link": "oklch(0.8031 0.1118 215.46)",
      "lureo-viewport-sky-top": "oklch(0.3281 0.0237 324)",
      "lureo-viewport-sky-bottom": "oklch(0.2118 0.028 324)",
      "lureo-viewport-floor": "oklch(0.2538 0.0264 324)",
      "lureo-viewport-grid": "oklch(0.3775 0.0293 280.66)",
      "lureo-viewport-grid-strong": "oklch(0.4368 0.0196 324)",
      "lureo-timeline-ruler-ink": "oklch(0.7879 0.0065 324)",
      "lureo-timeline-clip": "oklch(0.46 0.0187 324)",
      "lureo-timeline-track": "oklch(0.32 0.0240 324)",
      "lureo-timeline-track-strong": "oklch(0.4 0.0210 324)",
      "lureo-timeline-track-faint": "oklch(0.27 0.0258 324)",
      "lureo-timeline-track-faint-strong": "oklch(0.31 0.0243 324)",
      "lureo-timeline-clip-line": "oklch(0.72 0.0091 324)",
      "lureo-timeline-clip-on": "oklch(0.5055 0.1123 338.92)",
      "lureo-on-timeline-clip-on": "oklch(1 0 0)",
      "lureo-timeline-playhead": "oklch(0.9619 0 0)",
      "lureo-gizmo-ring": "oklch(0.9301 0.1043 170.39)",
      "lureo-handle": "oklch(0.87 0 0)",
      "lureo-style-bubble": "oklch(0.9409 0.087 186.65)",
      "lureo-tile-shade": "oklch(0.4228 0.0458 248.01)",
      "lureo-checker-light": "oklch(0.9034 0.006 310.97)",
      "lureo-checker-dark": "oklch(0.7038 0.0183 310.97)",
      "lureo-map-land": "oklch(0.2418 0.0269 324)",
      "lureo-map-water": "oklch(0.3768 0.0218 324)",
      "lureo-map-park": "oklch(0.2943 0.0249 324)",
      "lureo-map-line": "oklch(0.3318 0.0235 324)",
      "lureo-map-label": "oklch(0.7219 0.009 324)",
      "lureo-map-water-label": "oklch(0.5193 0.0165 324)",
      "lureo-map-parcel-label": "oklch(0.4143 0.0204 324)",
      "lureo-shadow-raised": "0px 4px 24px oklch(0.9145 0.1311 185.99 / 0.1)",
      "lureo-shadow-float": "0px 4px 24px oklch(0.9145 0.1311 185.99 / 0.1), 0 16px 48px oklch(0 0 0 / 0.6744)",
      "lureo-shadow-overlay": "0px 1px 10px 1px oklch(0 0 0 / 0.175), inset 0 1px 0 oklch(1 0 0 / 0), 0 0 0 1px oklch(0 0 0 / 0)",
      "lureo-shadow-bar": "0 8px 32px oklch(0 0 0 / 0.4496), 0 0 0 1px oklch(1 0 0 / 0.1)",
      "lureo-shadow-modal": "0px 16px 48px oklch(0 0 0 / 0.674), 0 0 0 1px oklch(1 0 0 / 0.15)",
      "lureo-shadow-lift": "0px 12px 40px oklch(0.9145 0.1311 185.99 / 0.15)",
      "lureo-shadow-lift-hover": "0px 12px 40px oklch(0.9145 0.1311 185.99 / 0.15)",
      "lureo-shadow-card-hover": "0px 4px 24px oklch(0.9145 0.1311 185.99 / 0.1)",
      "lureo-shadow-sheet": "inset 0 1px 0 oklch(1 0 0 / 0), 0 0 0 1px oklch(0 0 0 / 0), 0 0 19px 1.5px oklch(0 0 0 / 0)",
      "lureo-shadow-control": "0px 1px 2px oklch(0.2694 0.058 248.01 / 0.08)",
      "lureo-shadow-button": "0 0 #0000",
      "lureo-shadow-cta": "0 0 #0000",
      "lureo-shadow-outline-button": "0 0 #0000",
      "lureo-shadow-button-pressed": "0 0 #0000",
      "lureo-shadow-button-hover": "0 0 #0000",
      "lureo-shadow-outline-button-hover": "0 0 #0000",
      "lureo-shadow-cta-hover": "0 0 #0000",
      "lureo-shadow-tab": "0px 1px 2px oklch(0.2694 0.058 248.01 / 0.08)",
      "lureo-shadow-cta-pressed": "0 0 #0000",
      "lureo-shadow-outline-button-pressed": "0 0 #0000",
      "lureo-shadow-solid": "0 0 #0000",
      "lureo-shadow-solid-hover": "0 0 #0000",
      "lureo-shadow-solid-pressed": "0 0 #0000",
      "lureo-shadow-danger": "0 0 #0000",
      "lureo-shadow-danger-hover": "0 0 #0000",
      "lureo-shadow-danger-pressed": "0 0 #0000",
      "lureo-shadow-segment-on": "0px 1px 2px oklch(0.2694 0.058 248.01 / 0.08)",
      "lureo-shadow-panel-card": "0 0 #0000",
      "lureo-field-focus": "0 0 0 2px oklch(0.9145 0.1311 185.99 / 0.7)",
      "lureo-title-shadow": "none",
      "lureo-sheen": "1",
      "lureo-photo-shade": "1",
      "lureo-photo-shade-tint": "oklch(0.1697 0.0224 324)",
      "lureo-photo-brightness": "1",
      "lureo-photo-hover-brightness": "1",
      "lureo-photo-veil": "oklch(0 0 0 / 0)",
      "lureo-glass": "1",
      "lureo-blur-sm": "4px",
      "lureo-blur-lg": "16px",
      "lureo-radius": "0.75rem",
      "lureo-radius-control": "1rem",
      "lureo-radius-button-pill": "9999px",
      "lureo-border-width": "1px",
      "lureo-radius-sm": "0.5rem",
      "lureo-radius-lg": "1rem",
      "lureo-radius-xl": "1.5rem",
      "lureo-radius-pill": "9999px",
      "lureo-radius-control-lg": "1.5rem",
      "lureo-radius-tag": "9999px",
      "lureo-radius-tab": "0.5rem",
      "lureo-radius-tooltip": "0.75rem",
      "lureo-radius-avatar": "9999px",
      "lureo-radius-segmented": "9999px",
      "lureo-radius-chip": "9999px",
      "lureo-radius-menu": "0.75rem",
      "lureo-radius-dialog": "1rem",
      "lureo-radius-field": "0.75rem",
      "lureo-border-width-medium": "1.5px",
      "lureo-border-width-strong": "2px",
      "lureo-border-width-heavy": "3px",
      "lureo-line-style": "solid",
      "lureo-duration-fast": "150ms",
      "lureo-duration-moderate": "200ms",
      "lureo-duration-slow": "300ms",
      "lureo-duration-button": "300ms",
      "lureo-duration-slower": "500ms",
      "lureo-duration-slowest": "700ms",
      "lureo-duration-sweep": "1200ms",
      "lureo-backdrop-drift": "0s",
      "lureo-easing-standard": "cubic-bezier(0.4, 0, 0.2, 1)",
      "lureo-easing-enter": "cubic-bezier(0, 0, 0.2, 1)",
      "lureo-easing-exit": "cubic-bezier(0.4, 0, 1, 1)",
      "lureo-press-scale": "1",
      "lureo-card-hover-scale": "1.02",
      "lureo-photo-hover-scale": "1",
      "lureo-hero-press-scale": "0.995",
      "lureo-press-offset": "0px",
      "lureo-hover-offset": "0px",
      "lureo-hover-offset-x": "0px",
      "lureo-hover-scale": "1",
      "lureo-layer-bar": "40",
      "lureo-layer-overlay": "50",
      "lureo-layer-tooltip": "110",
      "lureo-layer-blocker": "9999",
      "lureo-layer-tour": "10000",
      "lureo-layer-toast": "10010",
      "lureo-font-ui": "ui-sans-serif, system-ui, sans-serif",
      "lureo-font-prose": "Fraunces, Georgia, serif",
      "lureo-font-mono": "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
      "lureo-font-display": "ui-sans-serif, system-ui, sans-serif",
      "lureo-weight-text": "400",
      "lureo-weight-heading": "700",
      "lureo-label-case": "none",
      "lureo-tab-case": "none",
      "lureo-title-case": "none",
      "lureo-label-tracking": "0em",
      "lureo-text-tracking": "0em",
      "lureo-font-features": "normal",
      "lureo-weight-subheading": "600",
      "lureo-weight-button": "600",
      "lureo-weight-label": "500",
      "lureo-title-tracking": "0em",
      "lureo-title-style": "normal",
      "lureo-label-style": "normal",
      "lureo-label-shadow": "none",
      "lureo-title-flicker": "0s",
      "lureo-title-leading": "1",
      "lureo-title-width": "100%",
      "lureo-title-indent": "0em",
      "lureo-title-fill": "none",
      "lureo-title-rule": "0px",
      "lureo-title-rule-ink": "oklch(0.9619 0 0)",
      "lureo-weight-overline": "300",
      "lureo-overline-case": "uppercase",
      "lureo-font-label": "ui-sans-serif, system-ui, sans-serif",
      "lureo-overline-ink": "oklch(0.7879 0.0065 324)",
      "lureo-overline-tracking": "0.15em",
      "lureo-texture-pattern": "none",
      "lureo-texture-strength": "0",
      "lureo-texture-size": "256px",
      "lureo-logo-style": "artwork"
    }
  }
];
